namespace $.$$ {

	export class $shm_hitalama_teams extends $.$shm_hitalama_teams {

		new_api_url( next?: string ) {
			return this.$.$mol_state_local.value(
				'$shm_hitalama_teams_new_api_url',
				next,
			) ?? ''
		}

		new_api_token( next?: string ) {
			return this.$.$mol_state_local.value(
				'$shm_hitalama_teams_new_api_token',
				next,
			) ?? ''
		}

		domain() { return this.$.$shm_hitalama_domain.instance() }

		current_user_id() {
			return this.$.$giper_baza_auth.current().pass().lord().str
		}

		teams() {
			return this.domain().teams_for_user( this.current_user_id() ).toSorted( ( left, right )=>
				this.team_title( left ).localeCompare( this.team_title( right ), 'ru' ),
			)
		}

		team_title( team: $shm_hitalama_team ) {
			return team.name() || team.link().toString()
		}

		team_id( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.dict({
					... this.$.$mol_state_arg.dict(),
					team: next || null,
					team_tab: 'info',
					team_member: null,
					projects_map: null,
					team_map: null,
				})
				return next
			}
			const requested = this.$.$mol_state_arg.value( 'team' ) ?? ''
			if( requested && this.teams().some( team => team.link().toString() === requested ) ) return requested
			return this.teams()[0]?.link().toString() ?? ''
		}

		selected_team() {
			const id = this.team_id()
			return this.teams().find( team => team.link().toString() === id ) ?? null
		}

		team_options() {
			return Object.fromEntries( this.teams().map( team => [ team.link().str, this.team_title( team ) ] ) )
		}

		team_picker_rows() {
			return [
				... this.teams().length > 1 ? [ this.Team_select() ] : [],
				this.Team_create_link(),
			]
		}

		team_new_uri() {
			return new this.$.$mol_state_arg( this.Team_create_link().state_key() ).link({
				section: 'team', team: this.team_id() || null, team_member: null, team_new: 'true',
			})
		}

		@ $mol_action
		team_new_click( next?: Event ) {
			if( next === undefined ) return null
			this.Team_picker().showed( false )
			return next
		}

		team_tab() {
			const value = this.$.$mol_state_arg.value( 'team_tab' )
			return value === 'members' || value === 'maps' ? value : 'info'
		}

		team_tab_current( id: string ) {
			return !this.team_new_opened() && this.team_tab() === id
		}

		team_tab_uri( id: string ) {
			return new this.$.$mol_state_arg( this.Team_info_link().state_key() ).link({
				section: 'team', team: this.team_id(), team_tab: id, team_member: null, team_new: null, help: 'off',
			})
		}

		selected_team_tab_title() {
			return ({ info: 'Общая информация', members: 'Участники', maps: 'Карты' })[ this.team_tab() ]
		}

		detail_content() {
			switch( this.team_tab() ) {
				case 'members': return [ this.Members_section() ]
				default: return [ this.Info() ]
			}
		}

		team_new_opened() {
			return this.$.$mol_state_arg.value( 'team_new' ) === 'true'
		}

		api_url_valid( source: string ) {
			return this.$.$mol_error_fence(
				()=> [ 'http:', 'https:' ].includes( new URL( source ).protocol ),
				()=> false,
			)
		}

		team_create_enabled() {
			return Boolean(
				this.new_name().trim()
				&& this.api_url_valid( this.new_api_url().trim() )
				&& this.new_api_token().trim()
			)
		}

		@ $mol_mem
		team_create_status( next?: string ) {
			return next ?? ''
		}

		@ $mol_mem
		team_create_status_kind( next?: 'done' | 'running' | 'failed' ) {
			return next ?? 'done'
		}

		team_create_status_color() {
			return this.team_create_status_kind() === 'failed'
				? `${ this.$.$shm_theme.error }`
				: this.team_create_status_kind() === 'running'
					? `${ this.$.$shm_theme.active }`
					: `${ this.$.$shm_theme.success }`
		}

		@ $mol_action
		team_create( next?: Event ) {
			if( next === undefined || !this.team_create_enabled() ) return null
			return this.$.$mol_error_fence(
				()=> {
					const profile = this.$.$shm_hitalama_profile.current()
					const creator_id = this.current_user_id()
					const team = this.domain().team_create(
						this.new_name(),
						this.new_api_url(),
						this.new_api_token(),
						creator_id,
						profile?.Login()?.val() || creator_id,
					)
					if( !team ) $mol_fail( new Error( 'Общий каталог команд недоступен для записи' ) )
					this.team_create_status( 'Команда создана' )
					this.team_create_status_kind( 'done' )
					this.new_name( '' )
					this.$.$mol_state_arg.dict({
						... this.$.$mol_state_arg.dict(),
						section: 'team',
						team: team.link().toString(),
						team_member: null,
						team_new: null,
					})
					return next
				},
				error => {
					this.team_create_status( error.message || 'Не удалось создать команду' )
					this.team_create_status_kind( 'failed' )
					return next
				},
				promise => {
					this.team_create_status( 'Создаём команду…' )
					this.team_create_status_kind( 'running' )
					throw promise
				},
			)
		}

		selected_team_name( next?: string ) {
			const team = this.selected_team()
			if( !team ) return ''
			return team.name( next )
		}

		selected_team_api_url( next?: string ) {
			const team = this.selected_team()
			if( !team ) return ''
			return team.projects_api_url( next )
		}

		selected_team_api_token( next?: string ) {
			const team = this.selected_team()
			if( !team ) return ''
			return team.projects_api_token( next )
		}

		selected_team_creator() {
			const id = this.selected_team()?.creator_id() || ''
			return this.member_name( id )
		}

		team_manage_allowed() {
			return this.selected_team()?.is_admin( this.current_user_id() ) ?? false
		}

		member_records() {
			return this.selected_team()?.member_records().toSorted( ( left, right )=>
				this.member_title( left ).localeCompare( this.member_title( right ), 'ru' ),
			) ?? []
		}

		member_title( member: $shm_hitalama_team_member ) {
			const id = member.User_id()?.val() || ''
			return this.$.$shm_hitalama_profile.user_name( id ) || member.Name()?.val() || id || member.link().toString()
		}

		member_by_user( id: string ) {
			return this.selected_team()?.member_by_user( id ) ?? null
		}

		member_name( id: string ) {
			const member = this.member_by_user( id )
			return member ? this.member_title( member ) : id
		}

		member_avatar_uri( id: string ) {
			return this.$.$shm_hitalama_profile.user_avatar_uri( this.member_user_id( id ) )
		}

		member_user_id( id: string ) {
			return this.member_by_user( id )?.User_id()?.val() || id
		}

		member_rows() {
			return this.member_records().map( member => this.Member_row( member.User_id()?.val() || member.link().toString() ) )
		}

		member_uri( id: string ) {
			return new this.$.$mol_state_arg( this.Member_name( id ).state_key() ).link({ section: 'team', team: this.team_id(), team_tab: 'members', team_member: id, team_new: null })
		}

		member_id_valid() {
			return /^[a-zA-Z0-9]{8}_[a-zA-Z0-9]{8}$/.test( this.member_id().trim().replace( /^@/, '' ) )
		}

		member_add_enabled() {
			return this.team_manage_allowed() && this.member_id_valid()
		}

		@ $mol_mem
		member_add_status( next?: string ) {
			return next ?? ''
		}

		@ $mol_mem
		member_add_status_kind( next?: 'done' | 'running' | 'failed' ) {
			return next ?? 'done'
		}

		member_add_status_color() {
			return this.member_add_status_kind() === 'failed'
				? `${ this.$.$shm_theme.error }`
				: this.member_add_status_kind() === 'running'
					? `${ this.$.$shm_theme.active }`
					: `${ this.$.$shm_theme.success }`
		}

		@ $mol_mem_key
		client_pass( [ id, land_id ]: readonly [ string, string ] ) {
			const land = encodeURIComponent( land_id )
			const source = this.$.$mol_fetch.text( `/hitalama_client_pass/${ encodeURIComponent( id ) }?land=${ land }` ).trim()
			const pass = this.$.$giper_baza_auth_pass.from( source )
			if( pass.lord().str !== id ) $mol_fail( new Error( 'Client pass does not match client ID' ) )
			return pass
		}

		member_pass( team: $shm_hitalama_team, id: string ) {
			const secret = team.secret()
			if( !secret ) $mol_fail( new Error( 'Не найден закрытый раздел команды' ) )
			const pass = this.client_pass([ id, team.land().link().str ])
			const secret_pass = this.client_pass([ id, secret.land().link().str ])
			if( secret_pass.toString() !== pass.toString() ) $mol_fail( new Error( 'Ключ пользователя изменился во время добавления' ) )
			return pass
		}

		@ $mol_action
		member_add( next?: Event ) {
			if( next === undefined || !this.member_add_enabled() ) return null
			const id = this.member_id().trim().replace( /^@/, '' )
			return this.$.$mol_error_fence(
				()=> {
					const team = this.selected_team()!
					const pass = this.member_pass( team, id )
					team.member_register( pass, id, this.$.$shm_hitalama_profile.user_name( id ) || id )
					this.member_id( '' )
					this.member_add_status( 'Участник добавлен' )
					this.member_add_status_kind( 'done' )
					return next
				},
				error => {
					this.member_add_status( error.message || 'Не удалось добавить участника' )
					this.member_add_status_kind( 'failed' )
					return next
				},
				promise => {
					this.member_add_status( 'Добавляем участника…' )
					this.member_add_status_kind( 'running' )
					throw promise
				},
			)
		}

		member_admin_enabled( id: string ) {
			return this.team_manage_allowed() && id !== this.selected_team()?.creator_id()
		}

		member_admin( id: string, next?: boolean ) {
			const team = this.selected_team()
			if( !team ) return false
			if( next === undefined ) return team.is_admin( id )
			if( !this.member_admin_enabled( id ) ) return team.is_admin( id )
			const pass = this.member_pass( team, id )
			return team.member_admin( id, pass, next )
		}

		member_id_selected() {
			return this.$.$mol_state_arg.value( 'team_member' ) ?? ''
		}

		selected_member() {
			return this.member_by_user( this.member_id_selected() )
		}

		selected_member_name() {
			const member = this.selected_member()
			return member ? this.member_title( member ) : 'Участник'
		}

		selected_member_user_id() {
			return this.selected_member()?.User_id()?.val() || ''
		}

		projects() {
			return this.$.$shm_projects_data.records().filter( project => !project.archived )
		}

		permission_rows() {
			return this.projects().map( project => this.Permission_row( project.id ) )
		}

		project_title( id: string ) {
			return this.$.$shm_projects_data.record( id )?.title || id
		}

		permission_manage_allowed() {
			return this.team_manage_allowed()
		}

		project_permission( kind: $shm_hitalama_team_project_permission, project: string, next?: boolean ) {
			const member = this.selected_member()
			if( !member ) return false
			const options = this.projects().map( item => item.id )
			const current = member.project_ids( kind )
			if( next === undefined ) return current.includes( '*' ) || current.includes( project )
			if( !this.permission_manage_allowed() ) return member.project_allowed( kind, project )
			const result = this.$.$shm_hitalama_team_project_toggle( current, options, project, next )
			member.project_ids( kind, result )
			return next
		}

		project_visible( id: string, next?: boolean ) { return this.project_permission( 'visible', id, next ) }
		project_prerelease( id: string, next?: boolean ) { return this.project_permission( 'prerelease', id, next ) }
		project_release( id: string, next?: boolean ) { return this.project_permission( 'release', id, next ) }

		team_pages() {
			const team = this.selected_team()
			if( !team ) return [ this.New_page() ]
			if( this.team_new_opened() ) return [ this.Team_menu_page(), this.New_page() ]
			if( this.team_tab() === 'maps' ) {
				if( !team.maps_list( null ) ) return [ this.Team_menu_page(), this.Team_maps_empty_page() ]
				return [ this.Team_menu_page(), ... this.Team_maps().pages() ]
			}
			return [
				this.Team_menu_page(),
				this.Detail_page(),
				...( this.selected_member() ? [ this.Member_page() ] : [] ),
			]
		}

	}

}
